/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_View_TableInputs */

const en_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table`)
};

const fr_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau`)
};

const de_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tisch`)
};

const it_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tavolo`)
};

const ru_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стол`)
};

const es_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesa`)
};

const zh_cn2_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌子`)
};

const ja_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーブル`)
};

const hi_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेज़`)
};

const pt_pt2_usage_view_table = /** @type {(inputs: Usage_View_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesa`)
};

/**
* | output |
* | --- |
* | "Table" |
*
* @param {Usage_View_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_view_table = /** @type {((inputs?: Usage_View_TableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_View_TableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_view_table(inputs)
	if (locale === "de") return de_usage_view_table(inputs)
	if (locale === "it") return it_usage_view_table(inputs)
	if (locale === "ru") return ru_usage_view_table(inputs)
	if (locale === "es") return es_usage_view_table(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_view_table(inputs)
	if (locale === "ja") return ja_usage_view_table(inputs)
	if (locale === "hi") return hi_usage_view_table(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_view_table(inputs)
	return en_usage_view_table(inputs)
});